"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBasketData = useBasketData;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../AccountProvider/selectors");
const slice_1 = require("./slice");
const useInterval_1 = require("../../hooks/useInterval");
const selectors_2 = require("../StorageProvider/selectors");
const selectors_3 = require("./selectors");
const useInterceptError_1 = require("../../hooks/useInterceptError");
const json_1 = require("../../utils/json");
const useHandleSystemSize_1 = require("./useHandleSystemSize");
const useHandleBasketOutcomesLength_1 = require("./useHandleBasketOutcomesLength");
const constants_1 = require("./constants");
function useBasketData(props) {
    var _a, _b, _c;
    const accountId = (0, react_redux_1.useSelector)(selectors_1.selectAccountId);
    const storage = (0, react_redux_1.useSelector)(selectors_2.selectStorage);
    const status = storage.coefficientStatusOnChanged;
    const coefficientStatusOnChanged = (0, react_redux_1.useSelector)(selectors_3.selectCoefficientStatusOnChanged);
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, useInterceptError_1.useInterceptError)({
        errorStatusesToTrigger: constants_1.BASKET_STATUS_ERRORS,
        errorSelector: selectors_3.selectBasketStatusErrors,
        onErrorSideEffect: (_b = (_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.interceptors) === null || _b === void 0 ? void 0 : _b.onErrorSideEffect,
    });
    (0, react_1.useEffect)(() => {
        if (status) {
            const parsedStatus = (0, json_1.jsonParse)(status, status);
            if (parsedStatus !== coefficientStatusOnChanged) {
                dispatch(slice_1.basketProviderActions.setCoefficientStatusOnChanged({
                    status: parsedStatus,
                }));
            }
        }
    }, [status, coefficientStatusOnChanged, dispatch]);
    (0, react_1.useEffect)(() => {
        if (accountId) {
            dispatch(slice_1.basketProviderActions.getBasket());
        }
    }, [accountId, dispatch]);
    const getBasket = (0, react_1.useCallback)(() => {
        if (accountId) {
            dispatch(slice_1.basketProviderActions.getBasket());
        }
    }, [accountId, dispatch]);
    (0, useInterval_1.useInterval)(getBasket, (props === null || props === void 0 ? void 0 : props.pollingInterval) === null
        ? null
        : (_c = props === null || props === void 0 ? void 0 : props.pollingInterval) !== null && _c !== void 0 ? _c : constants_1.GET_BASKET_POLLING_INTERVAL);
    (0, useHandleSystemSize_1.useHandleSystemSize)();
    (0, useHandleBasketOutcomesLength_1.useHandleBasketOutcomesLength)();
}
//# sourceMappingURL=useBasketData.js.map